import { datadogRum } from '@datadog/browser-rum';

/**
 * Track a named user action (button clicks, form submissions, etc.).
 * Shows up in RUM > Actions.
 *
 * @example
 * trackAction('sales_form_submitted', { step: 7, agentId });
 */
export function trackAction(name: string, context?: Record<string, unknown>) {
  datadogRum.addAction(name, context);
}

/** Associate the current RUM session with an authenticated user. Call after login. */
export function datadogSetUser(user: {
  id: string;
  name?: string;
  email?: string;
}) {
  datadogRum.setUser(user);
}

/**
 * Identify the user from a profiles array returned by getUserProfile().
 * Scans all profiles to find the first available name and email,
 * since not every profile is guaranteed to have both fields.
 */
export function datadogIdentifyFromProfiles(
  userId: string,
  profiles: Array<{ profile?: { name?: string; email?: string } }>
) {
  if (!userId) return;
  const name = profiles.find((p) => p.profile?.name)?.profile?.name;
  const email = profiles.find((p) => p.profile?.email)?.profile?.email;
  datadogRum.setUser({
    id: userId,
    ...(name && { name }),
    ...(email && { email }),
  });
}

/** Clear the user from the RUM session. Call on logout. */
export function datadogClearUser() {
  datadogRum.clearUser();
}
